import { ReactElement } from 'react';
import { Component as DiscountIcon } from 'icons/icon-circle--discount.svg';
import { Tooltip } from '../shared/tooltip/Tooltip';
import styles from './CouponTooltip.module.scss';

type Props = {
  couponAmount: string;
  tooltipMessage?: string;
}

export function CouponTooltip({ couponAmount, tooltipMessage }: Props): ReactElement {
  return (
    <div className={styles.coupon_container}>
      <DiscountIcon className={styles.discount_icon} />
      <div className={styles.discount_amount}>
        {`${couponAmount} off discount`}
        {tooltipMessage && (
          <Tooltip tooltipMessage={tooltipMessage}>
            <button
              className="c-link c-info-icon c-info-symbol"
              type="button"
              tabIndex={0}
            >
              &#9432;
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
